import { InnerBox } from "@/components/elements/InnerBox";
import { Button } from "@/components/elements/Button";
import { ExamStepProgressItem } from "@/features/exam-steps/components/ExamStepProgressItem";
import { useInitSetup } from "@/providers/InitSetupProvider";
import { AppRoutes } from "@/routes/config";
import { getDynamicRoute } from "@/utils/url";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useExamStepIndustries } from "@/api/services/main/exam-steps";
import { USER_TYPE } from "@/types/enum";

export const ExamStepsListPage: FC = () => {
  const navigate = useNavigate();
  const { userType, company } = useInitSetup();
  const { data: industriesData } = useExamStepIndustries();
  const industries = industriesData?.data ?? [];
  const industryNames = industries.map((industry) => industry.name);
  const shouldShowSettingsIndustryButton = userType === USER_TYPE.RSO_USER || userType === USER_TYPE.COMPANY_USER;

  const isCompanyInRso = userType === USER_TYPE.SUPPORT_USER;
  const unregisteredIndustryNote = isCompanyInRso ? "登録支援機関に確認をお願いします。" : "外国人管理からご登録ください。";

  const handleNavigateToIndustrySettings = () => {
    switch (userType) {
      case USER_TYPE.RSO_USER:
        navigate(AppRoutes.rsoEdit);
        break;
      case USER_TYPE.COMPANY_USER:
        if (!company) return;
        navigate(getDynamicRoute(AppRoutes.companyEdit, { companyId: company.id }));
        break;
      default:
        break;
    }
  };

  return (
    <Stack gap={3}>
      <Typography variant="head20Bold">受験手続</Typography>
      <InnerBox title="分野を選択" variantTitle="sub16Bold" showDivider={false}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={3} mt={2}>
          <Typography component="p" variant="body14">
            最初に確認したい分野を選択してください。外国人が未登録の分野は選択できません。{unregisteredIndustryNote}
            <br />
            下記に記載のない分野は、今後のアップデートをお待ちください。
          </Typography>
          {shouldShowSettingsIndustryButton && (
            <Button variant="outline" size="sm" onClick={handleNavigateToIndustrySettings}>
              対象分野を設定
            </Button>
          )}
        </Stack>
        <Stack gap={2}>
          {industries.map((industry) => (<ExamStepProgressItem key={industry.id} industry={industry} industryNames={industryNames} />))}
        </Stack>
      </InnerBox>
    </Stack>
  );
};
